import React from "react";
import Routes from "./Routes";
import ClinicProvider from "./Provider/ClinicProvider/ClinicProvider";
import ReviewProvider from "./Provider/ReviewProvider/ReviewProvider";
const App = () => {
  return (
    <React.Fragment>
      <ReviewProvider>
        <ClinicProvider>
          <Routes />
        </ClinicProvider>
      </ReviewProvider>
    </React.Fragment>
  );
};

export default App;
